module.exports = __webpack_public_path__ + "fonts/Segoe UI.076522f.woff";